import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { PusherService } from '../services/pusher.service';

export const socketIdInterceptor: HttpInterceptorFn = (req, next) => {
    const pusherService = inject(PusherService);
    if (!req.headers.has('X-Socket-ID')) {
        const socketId = pusherService.socketId();
        if (socketId) {
            req = req.clone({
                headers: req.headers.set('X-Socket-ID', socketId)
            });
        }
    }
    return next(req);
};
